<template>
	<c-modal @close="close" :title="'Uw gegevens wijzigen'">
		
		<c-form ref="form" @valid="submit" class="margin-t-40">

			<c-input 
				:label="'Naam'"
				:horizontal="true"
				:value="name"
				type="text" 
				name="name"
				v-model="name"
				required />

			<c-input 
				:label="'E-mailadres'"
				:horizontal="true"
				:value="email"
				type="email" 
				name="email"
				v-model="email"
				required />

			<div v-if="editUser">
				<c-select
				:label="'Rol'"
				:horizontal="true"
				:options="roles"
				:required="true"
				v-model="role"
				:ValueName="'name'"
				:name="'name'"
				multiple
			/>

			</div>

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Bewerken</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>
import Form from '@mixins/Form';
import CModal from '@components/Modal';

import { mapGetters } from 'vuex';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal,
	},
	data() {
		return {
			name: '',
			email: '',
			roles: '',
			role: [],
			endClients: [],
		};
	},
	props: {
		edit: {
			required: false,
		},
		editUser: {
			required: false
		}
	},
	computed: {
		...mapGetters({
			user: 'user/get'
		}),
	

	},
	methods: {
		submit() {
			let data = "";

			if(this.editUser){
 				data = {
					name: this.name,
					email: this.email,
					role: this.role,
					id: this.editUser.id,
				}
			}
			else {
				data = {
					name: this.name,
					email: this.email,
					id: this.user.id,
				}
			}	
		
			this.$xhr.put('/api/users/' + data.id, data).then( ( {result}) => {
				this.close();
				this.$emit('added');
				this.$store.dispatch('toast/success', {title: 'Gebruiker aanpassen', text: 'De gebruiker is aangepast'});
			}).catch( (e) => {
				if (e instanceof ValidationError) {
					this.$refs.form.setErrors(e.errors);
				}
				this.$store.dispatch('toast/alert', {title: 'Gebruiker aanpassen', text: 'Gebruiker kon niet opgeslagen worden'});
			});	
		
			this.close();

		},
		close() {
			this.$emit('close');
		},
	},
	mounted(){
		if(this.editUser){
			this.name = this.editUser.name;
			this.email =  this.editUser.email;

			if(this.editUser.roles.length > 0){
				this.role = this.editUser.roles.map(r => r.name);
			}

			this.$xhr.get('/api/roles' ).then( ( {result}) => {
					this.roles = result;
				}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Rollen kunnen niet worden ingeladen'});
				});	
		}
		else{
			this.name = this.user.name;
			this.email = this.user.email;
		}



	}
}
</script>